import { Dimmer, Loader } from 'semantic-ui-react'
import styled from 'styled-components'

const DinmmerBox = styled(Dimmer)`
    ${({ height }) => height && `height: ${height} !important`}
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000 !important;
`

export const LoaderBar = ({ content = 'Loading', height, ...rest }) => (
    <DinmmerBox active inverted page {...rest} height={height}>
        <Loader content={content} />
    </DinmmerBox>
)
